import type { ReactNode } from "react";
import { cn } from "../utils/cn";

type TableHeaderProps = {
  children: ReactNode;
  className?: string;
};

export function TableHeader({ children, className }: TableHeaderProps) {
  return <div className={cn("text-[11px] uppercase tracking-[0.04em] text-muted font-medium", className)}>{children}</div>;
}
